<template>
  <div class="picture" :class="$mq" :style="borderStyle">
    <img :src="require(`@/assets/images/${image}`)" alt="" />
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: String,
      default: 'default.png',
    },
    border: {
      type: String,
      default: 'none',
    },
  },
  computed: {
    borderStyle() {
      return `
        border-top: 1px solid ${this.border};
        border-bottom: 1px solid ${this.border};
      `
    },
  },
}
</script>

<style lang="scss" scoped>
.picture {
  max-width: 2560px;
  margin-inline: auto;
  width: 100%;
  &.sm,
  &.md {
    margin-bottom: 2em;
  }
  img {
    width: 100%;
  }
}
</style>
